import { render, staticRenderFns } from "./ObjectMarkTagPicker.vue?vue&type=template&id=998452d2&scoped=true&"
import script from "./ObjectMarkTagPicker.vue?vue&type=script&lang=ts&"
export * from "./ObjectMarkTagPicker.vue?vue&type=script&lang=ts&"
import style0 from "./ObjectMarkTagPicker.vue?vue&type=style&index=0&id=998452d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "998452d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VBtn,VChip,VCol,VRow})
